import {useEffect, useState} from 'react';
import * as Const from "../Const";
import axios from "axios";

function useMachines(session, isEnabled) {

    const [machines, setMachines] = useState([]);

    useEffect(() => {
        if (!isEnabled) {
            return;
        }

        if (session) {
            axios.get(Const.API_MACHINES,{withCredentials: true}).then(res => {
                const data = res.data;
                console.log("machines", data)
                setMachines(data)
            }).catch(error => {
                console.log(JSON.stringify(error));
                setMachines([]);
            });
        }
    }, [isEnabled, session]);

    return machines;
}

export default useMachines
